import SpeedyLogo from "./logo.png"
import React from 'react';

const logo = () => {
    return (
        <div>
            <img src={SpeedyLogo} alt="Speedy Logo" />
        </div>
    );
};

export default logo;